import React, { useEffect, useState } from 'react';

import { getRequest } from 'utils/api';
import { useSelector } from 'react-redux';
import { formatLargeNumber, getNetworkName } from 'utils/helpers';
import TypeAndFrequency from './TypeAndFrequency';
import styles from 'styles/components/gigs/GigDetails.module.scss';
import RowWithChip from 'components/RowWithChip';

const InfluencerInventory = ({ gig = {} }) => {
  const [popularityConditions, setPopularityConditions] = useState([]);
  const networks = useSelector(state => state.utils.networks);

  useEffect(() => {
    getRequest({
      endpoint: 'gig_popularity_conditions',
      query: { gig_id: gig.id },
    })
      .then(popularityConditions => setPopularityConditions(popularityConditions))
      .catch(() => {});
  }, [gig.id]);

  return (
    <div className={styles.gigDetailsContainer}>
      {/* In case we return the categories and audiences */}

      {/* <RowWithChip array={gig.categories} title="Category" /> */}

      {/* <RowWithChip array={gig.audiences} title="Influencer's audience interests" /> */}

      {popularityConditions.length > 0 && (
        <div className={styles.padding} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.15)' }}>
          <h3>Influencer popularity</h3>

          {[...popularityConditions]
            .sort((a, b) => a.network_id - b.network_id)
            .map(condition => (
              <div className={styles.milestone} key={condition.id}>
                {getNetworkName(networks, condition.network_id)}:{' '}
                <span>minimum {formatLargeNumber(condition.min_count)} followers</span>
              </div>
            ))}
        </div>
      )}

      {gig.type_and_frequency.length > 0 && <TypeAndFrequency gig={gig} />}
    </div>
  );
};

export default InfluencerInventory;
